<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.1722 18H1.5C0.672 18 0 17.328 0 16.5V1.5C0 0.672 0.672 0 1.5 0H12C12.828 0 13.5 0.672 13.5 1.5V4.5H12V2.25H1.5V15H9.75V16.875C9.75 17.268 9.8865 17.7563 10.1722 18ZM16.875 5.25C17.496 5.25 18 5.754 18 6.375V16.875C18 17.4945 17.4967 18 16.875 18H11.625C11.0033 18 10.5 17.4937 10.5 16.875V6.375C10.5 5.75475 11.0048 5.25 11.625 5.25H16.875ZM6.75 15.75C7.164 15.75 7.5 16.086 7.5 16.5C7.5 16.914 7.164 17.25 6.75 17.25C6.336 17.25 6 16.914 6 16.5C6 16.086 6.336 15.75 6.75 15.75ZM14.25 17.25C13.8352 17.25 13.5 16.914 13.5 16.5C13.5 16.086 13.8352 15.75 14.25 15.75C14.664 15.75 14.9993 16.086 14.9993 16.5C14.9993 16.914 14.664 17.25 14.25 17.25ZM17.25 15V7.482H11.25V15H17.25ZM14.625 6.75C14.8313 6.75 15 6.582 15 6.375C15 6.168 14.8313 6 14.625 6H13.875C13.668 6 13.5 6.168 13.5 6.375C13.5 6.582 13.668 6.75 13.875 6.75H14.625Z"
    [attr.fill]="color"
  />
</svg>
